"use strict";

var resolution = {
	Set: null,
	Switch: null,
	orientation: null,
	current: null,
	first: true
};

function isMobile() {
	if (window.matchMedia) {
		var isMobile = window.matchMedia("(max-width: 767px)");
		return isMobile.matches;
	} else {
		return false;
	}
}

function isTablet() {
	if (window.matchMedia) {
		var isTabletWidth = window.matchMedia("(min-width: 768px) and (max-width: 1439px)");
		var isTouch = Modernizr.touch;
		if (isTabletWidth.matches == true && isTouch == true) {
			return true;
		} else {
			return false;
		}
	}
}

function initDatepicker() {

	jQuery(document).ready(function ($) {

		$.datepicker.regional.nl = {
			closeText: 'Sluiten',
			prevText: '←',
			nextText: '→',
			currentText: 'Vandaag',
			monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
			monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
			dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
			dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
			dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
			weekHeader: 'Wk',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: '' };
		$.datepicker.setDefaults($.datepicker.regional.nl);

		$('input.datepicker').datepicker({
			changeYear: true,
			changeMonth: true,
			yearRange: "-100:+5",
			dateFormat: 'dd-mm-yy'
		});
	});
}

jQuery(document).ready(function ($) {

	$('#reset-search').click(function () {
		$('.form-home')[0].reset();
	});

	$('#new-search').click(function () {
		if ($('#fondszcontentnew').is(':visible')) {
			$('#fondszcontentnew').hide();
		} else {
			$('#fondszcontent').hide();
			$('#fondszcontentnew').show();
		}

		if ($('#fondszcontentnew:visible, #fondszcontent:visible').length > 0) {
			$('#fondszheader').attr('class', 'up');
			$('#fondszfooter').show();
		} else {
			$('#fondszheader').removeClass('up');
			$('#fondszfooter').hide();
		}

		return false;
	});

	$('#your-search').click(function () {

		// if ($('.new-search').hasClass('new-search-active') || $(this).hasClass('your-search-active')) {
		// 	$(this).removeClass('your-search-active');
		// 	$('#fondszcontent').hide();
		// 	$('#fondszfooter').hide();
		// 	$('#fondszheader').removeClass('up');
		// 	console.log('1');
		// } else {
		// 	$(this).addClass('your-search-active');
		// 	$('#fondszcontent').show();
		// 	$('#fondszfooter').show();
		// 	$('#fondszheader').attr('class','up');
		// 	console.log('2');
		// }

		if ($('#fondszcontent').is(':visible')) {
			$('#fondszcontent').hide();
		} else {
			$('#fondszcontentnew').hide();
			$('#fondszcontent').show();
		}

		if ($('#fondszcontentnew:visible, #fondszcontent:visible').length > 0) {
			$('#fondszheader').attr('class', 'up');
			$('#fondszfooter').show();
		} else {
			$('#fondszheader').removeClass('up');
			$('#fondszfooter').hide();
		}

		return false;
	});

	$("#projectbudget, #ondersteuning, #projectbudgetnew, #ondersteuningnew").blur(function () {
		$(this).parseNumber({ format: "#,###.", locale: "de" });
		$(this).formatNumber({ format: "#,###.", locale: "de" });
	});

	$("#leeftijdgroep, #leeftijdgroeptot, #leeftijdgroepnew, #leeftijdgroeptotnew").blur(function () {
		$(this).parseNumber({ format: "#,##0.", locale: "de" });
		$(this).formatNumber({ format: "#,##0.", locale: "de" });
	});

	jQuery('#fondszoeker .add').click(function () {
		if ($(this).is('.focusgroup-add') && $('#gender').val() == 'na') return false;

		var clone = jQuery(this).prev().clone();
		jQuery(clone).find('*').removeAttr('disabled');
		jQuery(this).parent().before(clone);
		jQuery(clone).find('.remove').click(function () {
			jQuery(this).parent().remove();
		});
		jQuery(clone).show();
		return false;
	});

	jQuery('#fondszoeker .remove').click(function () {
		jQuery(this).parent().remove();
	});

	// disable the age inputs when n/a is ticked
	jQuery('#noage').change(function () {
		if (jQuery(this).is(':checked')) {
			jQuery('#leeftijdgroep').addClass('disabled');
			jQuery('#leeftijdgroeptot').addClass('disabled');
			jQuery('#leeftijdgroep').attr('disabled', 'disabled');
			jQuery('#leeftijdgroeptot').attr('disabled', 'disabled');
			jQuery('#leeftijdgroep').val('');
			jQuery('#leeftijdgroeptot').val('');
		} else {
			jQuery('#leeftijdgroep').removeClass('disabled');
			jQuery('#leeftijdgroeptot').removeClass('disabled');
			jQuery('#leeftijdgroep').attr('disabled', null);
			jQuery('#leeftijdgroeptot').attr('disabled', null);
		}
	});

	// disable the age inputs when n/a is ticked
	jQuery('#noagenew').change(function () {
		if (jQuery(this).is(':checked')) {
			jQuery('#leeftijdgroepnew').addClass('disabled');
			jQuery('#leeftijdgroeptotnew').addClass('disabled');
			jQuery('#leeftijdgroepnew').attr('disabled', 'disabled');
			jQuery('#leeftijdgroeptotnew').attr('disabled', 'disabled');
			jQuery('#leeftijdgroepnew').val('');
			jQuery('#leeftijdgroeptotnew').val('');
		} else {
			jQuery('#leeftijdgroepnew').removeClass('disabled');
			jQuery('#leeftijdgroeptotnew').removeClass('disabled');
			jQuery('#leeftijdgroepnew').attr('disabled', null);
			jQuery('#leeftijdgroeptotnew').attr('disabled', null);
		}
	});

	jQuery('#noage').change(); //force state update when done loading the page

	jQuery('#noagenew').change(); //force state update when done loading the page

	jQuery('#gender').change(function () {
		if (jQuery(this).val() == 'na') {
			$('#fondszcontent .focusgroup-select option[value=-2]').attr('selected', 'selected');
			$('#fondszcontent .focusgroup-select').attr('disabled', 'disabled');
			$('#fondszcontent .focusgroup-select').addClass('disabled');
			$('#noage').attr('checked', 'checked');
			$('#noage').attr('disabled', 'disabled');
			$('#noage').change();
		} else {
			//$('.focusgroup-select option').removeAttr('selected');
			//$('.focusgroup-select option[value=-1]').attr('selected','selected');
			$('#fondszcontent .focusgroup-select').removeClass('disabled');
			$('#fondszcontent .focusgroup-select').removeAttr('disabled', 'disabled');
			$('#noage').removeAttr('disabled');
		}
	});
	if ($('#gender').val() == 'na') $('#gender').change();

	jQuery('#gendernew').change(function () {
		if (jQuery(this).val() == 'na') {
			$('#fondszcontentnew .focusgroup-select option[value=-2]').attr('selected', 'selected');
			$('#fondszcontentnew .focusgroup-select').attr('disabled', 'disabled');
			$('#fondszcontentnew .focusgroup-select').addClass('disabled');
			$('#noagenew').attr('checked', 'checked');
			$('#noagenew').attr('disabled', 'disabled');
			$('#noagenew').change();
		} else {
			//$('.focusgroup-select option').removeAttr('selected');
			//$('.focusgroup-select option[value=-1]').attr('selected','selected');
			$('#fondszcontentnew .focusgroup-select').removeClass('disabled');
			$('#fondszcontentnew .focusgroup-select').removeAttr('disabled', 'disabled');
			$('#noagenew').removeAttr('disabled');
		}
	});
	if ($('#gendernew').val() == 'na') $('#gendernew').change();

	//make entire search-result items clickable
	jQuery('.searchitem').click(function () {
		window.location = jQuery(this).find('a').attr('href');
	});

	// menu items with sub not clickable on touch devices
	if (isTablet() || isMobile()) {
		// jQuery('li#menu_area > a, li#menu_sector > a').on("click", function(e) {
		// 	console.log(1);
		// 	e.preventDefault();
		// });

		jQuery('div.row .info a').click(function (e) {
			e.preventDefault();
			$(this).find('.info_tekst').show();
		});
	}

	// mobile menu
	if (isMobile()) {

		var $header = $('#header'),
		    $menu = $('#menu'),
		    $search = $('#search'),
		    $menuBtn = $('.mobile-menu-btn'),
		    maxHeight = $(window).height() - 111;

		$menuBtn.on('click', function () {

			$("html, body").animate({ scrollTop: 0 }, "slow");

			if ($menuBtn.hasClass('open')) {
				$menuBtn.removeClass('open');
				$header.removeAttr('style');
				$search.removeAttr('style');
				$menu.slideUp();
				//$('body').removeAttr('style');
			} else {
				$menuBtn.addClass('open');
				$header.css({ 'position': 'fixed', 'top': 0 });
				$search.css({ 'margin-top': '126px' });
				$menu.slideDown();
				$('#menu .mobile-scroll').css({ 'max-height': maxHeight });
				//$('body').css('overflow','hidden');
			}
		});

		//var $plus = $menu.find('span.plus');

		$('#menu-main-menu > li.menu-item-has-children > a').on('click', function (e) {
			e.preventDefault();
			var $this = $(this).parent('li');
			if ($this.hasClass('open')) {
				$this.removeClass('open').find('.sub-menu').slideUp();
			} else {
				$this.addClass('open').find('.sub-menu').slideDown();
				$this.siblings('li').removeClass('open').find('.sub-menu').slideUp();
			}
		});
	}

	$(window).resize(function () {
		//adjustStyle($(this).width());
	});
	$(window).resize();
});

// Edit form fondsen (was inline script, hier naar toe verplaatst)
jQuery(document).ready(function () {
	jQuery('.editable').each(function () {
		if (jQuery(this).find('span:hidden').length > 0) {
			jQuery(this).html(jQuery(this).find('span:hidden').html());
		} else {
			var val = jQuery(this).attr('data') ? jQuery(this).attr('data') : jQuery(this).html() == '&lt;geen&gt;' ? '' : jQuery(this).html();
			var extraClass = jQuery(this).hasClass('small') ? 'class="small"' : '';
			extraClass += jQuery(this).hasClass('euro') ? 'class="euro"' : '';
			extraClass += jQuery(this).hasClass('maanden') ? 'class="maanden"' : '';
			jQuery(this).html('<input ' + extraClass + ' name="' + jQuery(this).attr('id') + '" value="' + val + '" />');
		}
	});
	registerEvents();
});

function registerEvents() {
	jQuery('#content_fonds select').unbind();
	jQuery('#content_fonds select').change(function () {
		if (!jQuery(this).next().next().is('#content_fonds select') || jQuery(this).next().next().length == 0) {
			var clone = jQuery(this).parent().find('.template').children().clone();
			jQuery(this).next().after(clone);
			registerEvents();
		}
	});
	jQuery('.rem').click(function () {
		jQuery(this).prev().remove();
		jQuery(this).remove();
	});

	jQuery("input.euro").blur(function () {
		jQuery(this).parseNumber({ format: "#,##0.", locale: "de" });
		jQuery(this).formatNumber({ format: "#,##0.", locale: "de" });
	});

	jQuery("input.euro").each(function () {
		if (jQuery(this).val() != '') {
			jQuery(this).blur();
		}
	});
	jQuery('.file-rem').click(function () {
		jQuery(this).parent().html('');
		$('#anbidelete').val('true');
	});
	jQuery('.privacy-file-rem').click(function () {
		jQuery(this).parent().html('');
		$('#privacydelete').val('true');
	});
}

$(function () {

	// Old Cookies:
	// $('.cookie-btn.toestaan').click(function() {
	// 	$('#cookiemelding').animate( {'bottom' : '-80px' }, 600);
	// 	$('#cookiemelding').delay(500).hide(0);
	// 	var date = new Date();
	// 	date.setTime(date.getTime()+(50*24*60*60*1000));
	// 	var expires = "; expires="+date.toGMTString();
	// 	document.cookie = 'cookie=yes'+expires+'; path=/'
	// });
	// $('.cookie-btn.sta-niet-toe').click(function() {
	//  	$('#cookiemelding').animate( {'bottom' : '-80px' }, 600);
	//  	$('#cookiemelding').delay(500).hide(0);
	//  	var date = new Date();
	//  	date.setTime(date.getTime()+(50*24*60*60*1000));
	//  	var expires = "; expires="+date.toGMTString();
	//  	document.cookie = 'cookie=no'+expires+'; path=/'
	// });
	// $('#cookiemelding').delay(2000).animate( {'bottom' : '0px' }, 600);

	// icons
	$('body').icons({
		ready: function ready(prop) {}
	});
	//$('body').icons.init('.svg-icon');

	// imageLoder
	$('.load-image').imageLoader({
		ready: function ready(prop) {
			// console.log(prop);
		},
		resize: function resize(prop) {
			// console.log(prop);
		}
	});

	// Scroller
	$(window).scroller({
		items: function items() {
			if (Modernizr.mq('(min-width: 768px)')) {
				scroll.mainnav.init();
			}
		},
		calculation: function calculation(pos) {
			scroll.mainnav.calculation(pos);
		},
		animation: function animation(pos) {
			scroll.mainnav.animation(pos);
		},
		resize: function resize() {
			scroll.mainnav.resize();
		}
	});

	// switch grid / resize functions
	resolution.Switch = function (size) {
		if (resolution.first === true) {
			resolution.first = false;
		} else {}
	};

	var resizeTimeout;
	$(window).resize(function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function () {
			resolution.Set();
		}, 100);
	});

	resolution.orientation = function () {};
	window.addEventListener('orientationchange', resolution.orientation);

	resolution.Set();

	// default resets
	// [placeholder]
	if (!Modernizr.input.placeholder) {
		$('[placeholder]').focus(function () {
			var input = $(this);
			if (input.val() == input.attr('placeholder')) {
				input.val('');
				input.removeClass('ph');
			}
		}).blur(function () {
			var input = $(this);
			if (input.val() === '' || input.val() == input.attr('placeholder')) {
				input.addClass('ph');
				input.val(input.attr('placeholder'));
			}
		}).blur();
		$('[placeholder]').parents('form').submit(function () {
			$(this).find('[placeholder]').each(function () {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
				}
			});
		});
	}

	// [title]
	$('[title]').each(function () {
		$(this).data('original-title', $(this).attr('title'));
	}).hover(function () {
		$(this).attr('title', '');
	}, function () {
		$(this).attr('title', $(this).data('original-title'));
	});

	// [buttons]
	$('[data-href]').click(function (e) {
		var target = $(e.target);
		if (target.not('a') && !target.parent('a').length) {
			if ($(this).attr('data-window') == 'new') {
				window.open($(this).attr('data-href'));
			} else {
				window.location.href = $(this).attr('data-href');
			}
			return false;
		}
	});
});

// switch grid / resize functions
resolution.Set = function () {
	var newResolution;
	if (Modernizr.mq('(max-width: 767px)')) {
		newResolution = 'mobile';
	} else if (Modernizr.mq('(max-width: 1023px)')) {
		newResolution = 'tablet';
	} else {
		newResolution = 'desktop';
		if (Modernizr.mq('(min-width: 1440px)')) {
			newResolution += ' wide';
		}
	}
	if ($('html').hasClass('no-borderradius')) {
		grid += ' IE8';
	}
	if (newResolution != resolution.current) {
		var resolutionClasses = ['mobile', 'tablet', 'desktop', 'wide', 'IE8'];
		$.each(resolutionClasses, function (i, v) {
			$('html').removeClass(v);
		});
		resolution.current = newResolution;
		$('html').addClass(resolution.current);
		resolution.Switch(resolution.current);
	}
};
$('#setGrid').ready(function () {
	resolution.Set();
});